import React from "react";
import Webcam from "react-webcam";
import CropGuide from "./CropGuide";
import { VIDEO_CONSTRAINTS } from "../constants/captureSettings";
import { buttonStyle, primaryButton } from "../styles/ui";

// Khu vực webcam: hình xem trước, lớp đếm ngược, đèn flash, chỉ báo tiến trình
// (đặt ngay trên khung hình cho gọn) và các nút bấm.
export default function CameraPanel({
    webcamRef,
    filterCss,
    mirrored,
    countdown,
    flashing,
    running,
    cropSlot,
    photoCount,
    stripSize,
    canShoot,
    captureLabel,
    onCapture,
    onCancel,
    onUpload,
    onRedo
}) {
    const shotLabel = Math.min(photoCount + 1, stripSize);

    return (
        <>
            <div style={preview}>
                <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/png"
                    videoConstraints={VIDEO_CONSTRAINTS}
                    mirrored={mirrored}
                    playsInline
                    style={{ width: "100%", display: "block", filter: filterCss }}
                />

                {cropSlot && <CropGuide slot={cropSlot} />}

                {/* Tiến trình nổi trên khung hình: đọc rõ trên nền tối, không tốn
                    thêm chiều cao ở dưới. */}
                <div style={progressOverlay}>
                    <div style={dotRow}>
                        {Array.from({ length: stripSize }, (_, i) => (
                            <span key={i} style={i < photoCount ? { ...dot, ...dotFilled } : dot} />
                        ))}
                    </div>
                    <span style={progressLabel}>
                        Tấm {shotLabel}/{stripSize}
                    </span>
                </div>

                {countdown != null && <div style={countdownOverlay}>{countdown}</div>}

                {/* Đèn flash: phủ trắng kín khung hình xem trước */}
                <div
                    style={{
                        ...flashOverlay,
                        opacity: flashing ? 1 : 0
                    }}
                />
            </div>

            <div style={actions}>
                {running ? (
                    <button style={{ ...primaryButton, flex: 1 }} onClick={onCancel}>
                        ⏹ Dừng
                    </button>
                ) : (
                    canShoot && (
                        <>
                            <button style={{ ...primaryButton, flex: 1 }} onClick={onCapture}>
                                {captureLabel}
                            </button>
                            <label style={{ ...buttonStyle, cursor: "pointer" }}>
                                ⬆ Tải ảnh
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={onUpload}
                                    style={{ display: "none" }}
                                />
                            </label>
                        </>
                    )
                )}

                {photoCount > 0 && !running && (
                    <button
                        style={redoButton}
                        onClick={onRedo}
                        title="Chụp lại tấm cuối"
                        aria-label="Chụp lại tấm cuối"
                    >
                        ⟳
                    </button>
                )}
            </div>
        </>
    );
}

const preview = {
    position: "relative",
    width: "100%",
    maxWidth: 400,
    borderRadius: 16,
    border: "3px solid rgba(255,255,255,0.85)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.28)",
    // Cắt gọn vệt đổ bóng rất rộng mà CropGuide dùng để làm tối vùng bị cắt bỏ.
    overflow: "hidden"
};

const progressOverlay = {
    position: "absolute",
    top: 10,
    left: 10,
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "5px 12px",
    borderRadius: 999,
    background: "rgba(38,15,11,0.55)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    pointerEvents: "none"
};

const dotRow = {
    display: "flex",
    alignItems: "center",
    gap: 6
};

const countdownOverlay = {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "clamp(72px, 22vw, 96px)",
    fontWeight: "bold",
    color: "white",
    textShadow: "0 4px 20px rgba(0,0,0,0.6)",
    background: "rgba(0,0,0,0.25)",
    pointerEvents: "none"
};

const flashOverlay = {
    position: "absolute",
    inset: 0,
    background: "#fff",
    pointerEvents: "none",
    // Bật thì hiện ngay lập tức, tắt thì mờ dần cho êm mắt.
    transition: "opacity 260ms ease-out"
};

const actions = {
    marginTop: 14,
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    alignItems: "stretch"
};

const dot = {
    width: 10,
    height: 10,
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.75)",
    background: "transparent",
    boxSizing: "border-box"
};

const dotFilled = {
    borderColor: "#ff7aa2",
    background: "#ff7aa2"
};

const progressLabel = {
    fontFamily: "Broline",
    color: "#ffe9d6",
    fontSize: 15,
    lineHeight: 1
};

const redoButton = {
    ...buttonStyle,
    flex: "0 0 auto",
    fontSize: 22,
    padding: "4px 14px",
    lineHeight: 1
};
